export { default } from './CarouselTriggers';
